import axios from 'axios';

export const isPlanLimitErrorResponse = (error: any): boolean => {
  if (!axios.isAxiosError(error)) return false;

  if (error.response?.status === 403 && error.response?.data?.error === 'CoachBeyondPlanLimits')
    return true;

  return false;
};

export const errorResponseCode = (error: unknown): string | undefined => {
  if (!axios.isAxiosError(error)) return undefined;

  const code = error.response?.data?.error;
  return typeof code === 'string' ? code : undefined;
};
